<template>
  <div class="page-content">
    <h1 class="page-title">{{ $locale("sideMenu.cinemaWebsite.companyInfo") }}</h1>
    <el-form
      class="egl-elm egl-detail"
      :model="form"
      ref="detailForm"
      label-position="top"
    >
      <el-row v-for="item in formItems" :key="item.prop">
        <el-col :span="10">
          <el-form-item
            :label="item.label"
            :prop="item.prop"
          >
            <el-input
              :placeholder="item.placeholder"
              v-model="form[item.prop]" />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <el-row>
      <el-col :span="24" style="text-indent: 420px;">
        <el-button style="width: 200px;" class="egl-btn-yellow" @click="save_fn">{{ $locale("global.confirm2") }}</el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { getCompanyInfoService, updateCompanyInfoService } from "@/helpers/service/api/cinemaWebsite";
import countDownAlert from "@/utils/countDownAlert";
export default {
  data() {
    return {
      form: {
        companyName: "",
        establishedYear: "",
        business: "",
        capital: "",
        representation: "",
        phoneNumber: "",
      },
      formItems: [
        {
          label: this.$locale("cinemaWebsite.companyInfo.formItem.companyName"),
          prop: "companyName",
          placeholder: this.$locale("cinemaWebsite.companyInfo.formItem.companyName.plsInput")
        },
        {
          label: this.$locale("cinemaWebsite.companyInfo.formItem.establishedYear"),
          prop: "establishedYear",
          placeholder: this.$locale("cinemaWebsite.companyInfo.formItem.establishedYear.plsInput")
        },
        {
          label: this.$locale("cinemaWebsite.companyInfo.formItem.business"),
          prop: "business",
          placeholder: this.$locale("cinemaWebsite.companyInfo.formItem.business.plsInput")
        },
        {
          label: this.$locale("cinemaWebsite.companyInfo.formItem.capital"),
          prop: "capital",
          placeholder: this.$locale("cinemaWebsite.companyInfo.formItem.capital.plsInput")
        },
        {
          label: this.$locale("cinemaWebsite.companyInfo.formItem.representation"),
          prop: "representation",
          placeholder: this.$locale("cinemaWebsite.companyInfo.formItem.representation.plsInput")
        },
        {
          label: this.$locale("cinemaWebsite.companyInfo.formItem.phoneNumber"),
          prop: "phoneNumber",
          placeholder: this.$locale("cinemaWebsite.companyInfo.formItem.phoneNumber.plsInput")
        }
      ]
    };
  },
  created() {
    getCompanyInfoService({
      cinemaId: window.localStorage.getItem("cinemaId")
    }).then(res => {
      if (res.data && res.success) {
        this.form = res.data;
      }
    });
  },
  methods: {
    requestScuessFn(res, countDownText) {
      if (!res.success) { return; }
      countDownAlert({
        content: countDownText,
      });
    },
    save_fn() {
      const requestParam = {
        ...this.form,
        cinemaId: window.localStorage.getItem("cinemaId"),
      };
      updateCompanyInfoService(requestParam).then(res => {
        this.requestScuessFn(res, this.$locale("global.updateSuccessfully"));
      });
    }
  }
};
</script>